import Http from '../request/Http';

export function getOverviewDatas() {
  return Http.get('/dashboard/statistics');
}

export function getMapLocks() {
  return Http.get('/dashboard/map/locks');
}

export function getSwitchDatas() {
  return Http.get('/dashboard/unlockdatas');
}

export function getSettingDatas() {
  return Http.get('/dashboard/settingdatas');
}

export function getChartDatas(begintime, endtime) {
  return Http.get('/dashboard/chart', {
    begintime,
    endtime,
  });
}

export function getTasks() {
  return Http.get('/dashboard/tasks');
}

export function getMapWorkers() {
  return Http.get('/dashboard/map/workers', {
    time: 0,
  });
}

export function getAuthperiod() {
  return Http.get('/dashboard/authperiod');
}

export function getBITasks() {
  return Http.get('/dashboard/bi/tasks');
}

// 领出归还记录
export function getBIKeyBoxDatas() {
  return Http.get('/dashboard/bi/keboxdatas');
}

export function getBITasksDownLoad() {
  return Http.get('/dashboard/bi/tasks/download');
}

export function getBIStatisticData() {
  return Http.get('/dashboard/bi/statistics');
}

export function getChartDatasForDeptLockSwitch(timespantype) {
  return Http.get('/dashboard/bi/chart/dept/lockswitch', {
    timespantype,
  });
}

export function getChartDatasForTimepsanLockSwitch(timespantype) {
  return Http.get('/dashboard/bi/chart/lockswitch', {
    timespantype,
  });
}

export function getAnalyzeDataChart(timespantype) {
  return Http.get('/dashboard/bi/chart/analyzedata', {
    timespantype,
  });
}
// 获取大屏钥匙柜钥匙盒相关统计
export function getBIStatisticDataForKeyBoxAndKeycabinet() {
  return Http.get('/dashboard/bi/statistics/keybox/keycabinet');
}
